import { bindable, bindingMode, customElement, observable } from 'aurelia-framework';
import { I18N } from 'aurelia-i18n';
import { BaseCustomElement } from 'Common/BaseCustomElement';
import { ObjectHelper } from 'Code/Helpers/ObjectHelper';
import { StringHelper } from 'Code/Helpers/StringHelper';
import { activationStrategy } from 'aurelia-router';
import { autoinject } from 'aurelia-dependency-injection';

@autoinject
export class RangeBaseCustomElement extends BaseCustomElement {

    @bindable({ defaultBindingMode: bindingMode.twoWay }) value: number = null;
    @bindable({ defaultBindingMode: bindingMode.toView }) editable: boolean = true;

    @bindable({ defaultBindingMode: bindingMode.toView }) entityName: string = StringHelper.Empty();
    @bindable({ defaultBindingMode: bindingMode.toView }) columnName: string = StringHelper.Empty();
    @bindable({ defaultBindingMode: bindingMode.toView }) onChange: any = null;
    @bindable({ defaultBindingMode: bindingMode.toView }) forceChange: boolean = false;
    @bindable({ defaultBindingMode: bindingMode.toView }) tabIndexId: number = -1;
    @bindable({ defaultBindingMode: bindingMode.toView }) configJson: any = null;
    @bindable({ defaultBindingMode: bindingMode.toView }) style: string = 'Numbers';

    private element: any = null;
    private i18n: I18N = null;
    private min: number = 1;
    private max: number = 5;
    private minLabel: string = 'Bad';
    private maxLabel: string = 'Excellent';
    private items: Array<number> = [];
    private step: number = 1;
    private captionSuffix: string = '';
    private decimalPlace: number = 0;

    constructor(i18n: I18N, element: Element,) {
        super();
        this.i18n = i18n;
        this.element = element;
    }

    bind() {
    }

    attached() {
                if (this.style == 'Range') {
            if (this.value == null && this.style == 'Range') {
                this.value = 0;
            }
        }
        if (this.style == 'Numbers') {
            for (let i1 = this.min; i1 <= this.max; i1++) {
                this.items.push(i1);
            }
        }
    }



    private SelectItem(v: number) {
        this.value = v;
    }

    detached() {
    }

    valueChanged(newValue, oldValue) {
        if (newValue) {
            if (ObjectHelper.IsNotNullAndUndefined(this.onChange) && !this.forceChange) {
                this.onChange();
            }
        }
    }
}
